export const INCENTIVE_SCENARIOS = {
	FREE_USER_FEATURE: 'free_user_feature',
	FREE_USER_DAILY: 'free_user_daily',
	FREE_USER_UPGRADE_PLAN: 'free_user_upgrade_plan',
	CANCEL_USER: 'cancel_user',
};

const FREE_USER_SCENARIOS = [
	INCENTIVE_SCENARIOS.FREE_USER_FEATURE,
	INCENTIVE_SCENARIOS.FREE_USER_DAILY,
	INCENTIVE_SCENARIOS.FREE_USER_UPGRADE_PLAN,
];

export const isFreeUserScenario = (scenarioName) => {
	return FREE_USER_SCENARIOS.includes(scenarioName);
};

export const isCancelScenario = (scenarioName) => {
	return scenarioName === INCENTIVE_SCENARIOS.CANCEL_USER;
};